import { useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../components/layout/AuthLayout';
import { Button } from '../../components/buttons/button';
import { Input } from '../../components/ui/input';
import { ICONS } from '../../constants/imageConstants';
import { authService } from '../../services/authService';
import AuthAlerts from '../../components/common/AuthAlerts';
import { useAuthForm } from '../../hooks/useAuthForm';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  
  const {
    formData,
    submitting,
    error,
    setError,
    onChange,
    handleSubmit
  } = useAuthForm({ email: '' }, 'forgot-password');

  const onSubmit = (e) => {
    handleSubmit(
      e,
      () => authService.requestPasswordReset({ email: formData.email }),
      () => {
        navigate('/login', { 
          state: { successMessage: `We've emailed a password reset link to ${formData.email}` },
          replace: true 
        });
      }
    );
  };

  return (
    <AuthLayout>
      <div className="mb-8 text-center">
        <h2 className="mb-2 text-2xl sm:text-3xl font-bold text-gray-800">Forgot Your Password?</h2>
        <p className="text-gray-600 font-medium text-base">Enter your email below to receive a password reset link.</p>
      </div>
      
      {error && (
        <div className="mb-6 animate-in fade-in slide-in-from-top-2">
          <AuthAlerts type="error" message={error} onClear={() => setError('')} />
        </div>
      )}
      
      <form onSubmit={onSubmit} className="space-y-6" noValidate>
        <Input
          id="forgot-password-email"
          name="email"
          label="Email"
          type="email"
          value={formData.email}
          onChange={onChange}
          placeholder="Enter your email"
          className="input-base"
        />
        
        <Button 
          type="submit"
          variant="primary"
          fullWidth
          size="large"
          disabled={submitting || !formData.email}
          loading={submitting}
        >
          {!submitting && (
           <div className="flex items-center gap-2">
              <img src={ICONS.REFRESH} alt="" className="h-4 w-4 brightness-0 invert" />
              <span>Send Reset Link</span>
            </div>
          )}
          {submitting && <span>Sending...</span>}
        </Button>
        
        <div className="text-center">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-sm font-medium text-gray-600"
          >
            Back to <span className="text-blue-500 font-semibold hover:underline">Log in</span>
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
